import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// OnboardingLayout.tsx
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import LayoutWrapperHOC from "../layout.wrapper.hoc";
import { LayoutCodes } from "../../utils/enums/LayoutCodes";
import { useDispatch, useSelector } from "react-redux";
import { selectUser, setUserMetadata } from "../../store/slices/user-slice";
import { isAuthenticated } from "@corporate-trip-planner-fe/ui-components";
import { fetchUserMetaData } from "../../services/api/UserService";
var CommonLayout = function (_a) {
    var children = _a.children;
    var TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;
    var dispatch = useDispatch();
    var metadata = useSelector(selectUser.userMetaData);
    var lastFetched = useSelector(selectUser.lastFetched);
    var configureUserMetadata = function () { return __awaiter(void 0, void 0, void 0, function () {
        var authenticated, data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    authenticated = isAuthenticated();
                    if (!authenticated) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchUserMetaData()];
                case 2:
                    data = _a.sent();
                    if (data.statusCode === 200) {
                        dispatch(setUserMetadata(data.result));
                    }
                    else {
                        throw new Error();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error("Failed to load user metadata: ", err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var currentTime = Date.now();
        var isStale = currentTime - lastFetched > TWENTY_FOUR_HOURS_MS;
        // 1. If data is empty OR 2. If data is older than 24 hours
        if (!metadata || isStale) {
            configureUserMetadata();
        }
    }, [metadata, lastFetched, dispatch]);
    return (_jsx(_Fragment, { children: _jsx(Outlet, {}) }));
};
export default LayoutWrapperHOC(CommonLayout, {
    layoutType: LayoutCodes.COMMON,
});
